import React from 'react'
import { termsAndconditions } from 'constants/flightsCreditRebooking'
import BodyText from 'LuxKit/Typography/BodyText'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

interface Props {
  flightCreditFee: number
  currency: string
  className?: string
}

function TermsAndConditionsList(props: Props) {
  const { className, flightCreditFee, currency } = props

  return <VerticalSpacer gap={4} className={className}>
    {termsAndconditions.map((content, index) =>
      <BodyText key={index} variant="large">
        {index === 2 && `${index + 1}. Luxury Escapes reduced service fee - $${flightCreditFee} ${currency} per person, per ticket.`}
        {index !== 2 && `${index + 1}. ${content}`}
      </BodyText>,
    )}
  </VerticalSpacer>
}

export default TermsAndConditionsList
